import { RefreshCw01Icon } from '@langchain/untitled-ui-icons';

import { useRunsQuery } from '@/hooks/useSwr';
import { GetRunsQueryParams, RunSchema } from '@/types/schema';
import { cn } from '@/utils/tailwind';

const REFRESH_INTERVAL = 30000; // 30 seconds

export function LoadLatestButton(props: {
  onClick: () => void;
  datasetShareToken?: string;
  fullFilter: GetRunsQueryParams;
  existingRuns?: RunSchema[];
  runsLoading: boolean;
  hasPeeked: boolean;
}) {
  const { data: runsPages } = useRunsQuery(
    { ...props.fullFilter, limit: 1, select: ['id'], skip_pagination: true },
    { datasetShareToken: props.datasetShareToken },
    {
      refreshInterval: REFRESH_INTERVAL,
      errorRetryCount: 0,
    }
  );

  const firstRunId = runsPages?.runs[0]?.id;
  const shouldShow =
    firstRunId &&
    !props.runsLoading &&
    !props.existingRuns?.some((run) => run.id === firstRunId);

  return (
    <button
      type="button"
      className={cn(
        'flex w-full items-center  gap-2 overflow-hidden bg-brand-green-400 px-4 text-white',
        'transition-all duration-300',
        props.hasPeeked ? 'justify-start' : 'justify-center',
        shouldShow ? 'h-10' : 'h-0'
      )}
      onClick={props.onClick}
    >
      <RefreshCw01Icon className="h-4 w-4" /> Load latest
    </button>
  );
}
